import styled, { css } from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'
import Text from 'components/shared/Text'

interface WrapperProps {
    isChecked: boolean
    hasDarkMode?: boolean
}

export const AbsoluteText = styled(Text)`
    position: absolute;
`

export const Inner = styled.div`
    background-color: ${({ theme }) => theme.colors.primary_500};
    width: 115px;
    height: 34px;
    border-radius: 57px;
    transition: margin 200ms linear;
    flex-shrink: 0;

    @media ${respondAbove.xl} {
        width: 114px;
        height: 36px;
    }
`
export const Wrapper = styled.div<WrapperProps>`
    user-select: none;
    position: relative;
    width: 240px;
    height: 44px;
    display: flex;
    padding: 5px;
    align-items: center;
    background-color: ${({ theme, hasDarkMode }) =>
        hasDarkMode ? 'transparent' : theme.colors.grayscale_0};
    border: 2px solid ${({ theme }) => theme.colors.grayscale_400};
    border-radius: 24px;
    cursor: pointer;

    @media ${respondAbove.xl} {
        height: 48px;
        padding: 8px 6px;
    }

    ${({ isChecked }) =>
        isChecked &&
        css`
            ${Inner} {
                margin-left: calc(50% - 3px);
            }
        `}
    ${AbsoluteText} {
        right: 33px;
        @media ${respondAbove.xl} {
            right: 35px;
        }
        &:first-of-type {
            left: 33px;
            @media ${respondAbove.xl} {
                left: 35px;
            }
        }
    }
    &:focus-visible {
        ${Inner} {
            background-color: ${({ theme }) => theme.colors.primary_700};
        }
    }
`
